import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FirstSection from './components/FirstSection';
import SecondSection from './components/SecondSection';
import ThirdSection from './components/ThirdSection';
import FourthSection from './components/FourthSection';
import PrivacyPolicy from './components/PrivacyPolicy'
import Footer from './components/Footer';
import ReactGA from 'react-ga';

ReactGA.initialize('AW-16904170679');

function HomePage() {
  return (
    <div className="bg-darkerBlue flex flex-col">
      <section className="flex flex-col justify-center items-center bg-darkerBlue text-white mb-10">
        <FirstSection />
      </section>
      <section className="flex flex-col justify-center items-center bg-darkerBlue text-white mb-10">
        <SecondSection />
      </section>
      <section className="flex flex-col justify-center items-center bg-darkerBlue text-white mb-10">
        <ThirdSection />
      </section>
      <section className="flex flex-col justify-center items-center bg-darkerBlue text-white mb-10">
        <FourthSection />
      </section>
      <section className="flex w-full flex-col justify-center items-center bg-darkerBlue text-white mb-10">
        <Footer/>
      </section>
    </div>
  );
}

export default function App() {
  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}
